import React, { PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class Loader extends PureComponent {
    render() {
        return (
            <div className={'loader'}>
                <div className={'texts'}>
                    <div className={'loading-text'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.loading`} />
                    </div>
                    <div className={'data-text'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.text`} />
                    </div>
                </div>
            </div>
        )
    }
}
